import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup__header absolute"
}
const _hoisted_2 = {
  key: 0,
  class: "popup__header"
}
const _hoisted_3 = { class: "popup__title" }
const _hoisted_4 = {
  key: 0,
  class: "popup__footer"
}

import BackButton from "@/components/UI/Button/BackButton.vue";
import CloseButton from "@/components/UI/Button/CloseButton.vue";
import Popup from "@/components/UI/Pupup/Popup.vue";
import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FullPopup',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    padding: { type: Boolean, default: true },
    closed: { type: Boolean },
    withoutAction: { type: Boolean },
    theme: { default: 'light' }
  }, {
    "show": {},
    "showModifiers": {},
  }),
  emits: ["update:show"],
  setup(__props: any, { expose: __expose }) {

const props = __props
const show = _useModel(__props, 'show')
const onBack = () => {
  show.value = false;
}
const content = ref<HTMLElement>()

__expose(
    {
      scrollToTop: () => {

        if (content.value) {
          content.value.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
      },
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    theme: _ctx.theme,
    ref: "popup"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        (_ctx.closed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(CloseButton, {
                onClick: onBack,
                theme: _ctx.theme
              }, null, 8, ["theme"])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.withoutAction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(BackButton, { onClick: onBack }),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["popup__content", {padding: _ctx.padding}]),
        ref_key: "content",
        ref: content
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["show", "theme"]))
}
}

})